import { mapKeys, orderBy } from 'lodash';
import { Tag } from '../models/Tag';

type CountryOption = {
  title: string;
  key: string;
};

export const filterCompanyTags = (tags: Tag[]): Tag[] => {
  return tags.filter((tag) => tag.tagId.startsWith('company/'));
};

const mapTagChild = (tag, prefix) => {
  let children: any = null;
  if (tag.children) {
    // eslint-disable-next-line no-param-reassign
    children = tag.children.map((child) => mapTagChild(child, prefix));
  }

  return {
    key: tag.tagId.replace(`${prefix}/`, ''),
    title: tag.displayName,
    children: children?.length > 0 ? children : null,
  };
};

const mapTags = (tags, prefix) => {
  return tags.map((child) => mapTagChild(child, prefix));
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const mapSectors = (sectors) => {
  return mapTags(sectors, 'sector');
};

export const fixCountryNamesBaseOnTags = (countryOptions: CountryOption[], tagIdToNameLookup: Record<string, string>): CountryOption[] => {
  const normalizedLookup = mapKeys(tagIdToNameLookup, (_v, k) => k?.toLowerCase());

  for (const countryOption of countryOptions) {
    const tagId = `country/${countryOption.key?.toLowerCase()}`;
    countryOption.title = normalizedLookup[tagId];
  }

  return orderBy(countryOptions, 'title');
};

const createTagChildMap = (tag, map = {}) => {
  // eslint-disable-next-line no-param-reassign
  map[tag.key] = tag.title;

  if (tag.children) {
    for (const child of tag.children) {
      createTagChildMap(child, map);
    }
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createTagMap = (tags, map = {}) => {
  for (const item of tags.data) {
    createTagChildMap(item, map);
  }

  return map;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parseTag = (tag?) => {
  return tag?.split('/');
};
